import { render } from "./VLoading.vue?vue&type=template&id=aeb07ba2&ts=true&lang=html"
import script from "./VLoading.vue?vue&type=script&lang=ts"
export * from "./VLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__